"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const stockpile_types_1 = require("./stockpile.types");
const moment_1 = __importDefault(require("moment"));
const initialState = {
    dataTon: [],
    dataTrip: [],
    dataGrid: [],
    errorCode: 0,
    isError: false,
    isSubmit: false,
    isLoading: true,
    isExport: false,
    errorMessage: '',
    isSuccess: false,
    mutationMode: false,
    dataGridHistory: [],
    isLoadingExport: false,
    isLoadingModify: false,
    isLoadingUpload: false,
    isLoadingDeleted: false,
    isLoadingHistory: false,
    isLoadingDownload: false,
    lastUpdated: new Date(),
    dataGridDeletedList: [],
    dataCheckpoint: [],
    dataDumptruck: [],
    dataItem: {
        id: '',
        pit_id: '',
        pos_id: '',
        area_id: '',
        seam_id: '',
        penalty: '',
        brand_id: '',
        pit_name: '',
        pos_name: '',
        lead_time: '',
        area_name: '',
        seam_name: '',
        ticket_no: '',
        queue_time: '',
        brand_name: '',
        created_by: '',
        nett_volume: 0,
        modified_by: '',
        dumptruck_id: '',
        dumptruck_no: '',
        excavator_id: '',
        excavator_no: '',
        delete_reason: '',
        capacity_volume: 0,
        contractor_name: '',
        contractor_dt_id: '',
        contractor_ex_id: '',
        time_in: new Date(),
        gate_in: new Date(),
        time_out: new Date(),
        gate_out: new Date(),
        is_duplicated: false,
        contractor_dt_code: '',
        contractor_ex_code: '',
        created_date: new Date(),
        modified_date: new Date(),
        main_entrance_in: new Date(),
        image_penalty_evidence: '',
        filename_penalty_evidence: '',
        checkpoint_name: '',
        checkpoint: {
            checkpoint_id: '',
            checkpoint_name: '',
        },
        area: {
            id: '',
            area_name: '',
        },
        brand: {
            id: '',
            name: '',
        },
        excavator: {
            id: '',
            excavator_no: '',
        },
        contractor: {
            id: '',
            contractor_name: '',
        },
        pit: {
            id: '',
            pit: '',
        },
        seam: {
            id: '',
            seam: '',
        },
        dump_truck: {
            id: '',
            dumptruck_no: '',
        },
    },
    dataStates: {
        skip: 0,
        take: 10,
        total: 0,
        sortable: true,
        filterable: true,
        reorderable: false,
        scrollable: 'scrollable',
        sort: [{ field: 'gate_in', dir: 'desc' }],
        end_date: (0, moment_1.default)(new Date()).format('YYYY-MM-DD'),
        start_date: (0, moment_1.default)(new Date()).format('YYYY-MM-DD'),
    },
    dataItemDeletedList: {
        id: '',
        reason: '',
        ticket_no: '',
        nett_volume: 0,
        modified_by: '',
        dumptruck_id: '',
        dumptruck_no: '',
        contractor_id: '',
        contractor_name: '',
        modified_date: new Date(),
        main_entrance_in: new Date(),
        gate_in: '',
    },
    dataStatesDeletedList: {
        skip: 0,
        take: 10,
        total: 0,
        sortable: true,
        filterable: true,
        reorderable: false,
        scrollable: 'scrollable',
        sort: [{ field: 'modified_date', dir: 'desc' }],
    },
    dataItemHistory: {
        id: '',
        type: '',
        status: '',
        filename: '',
        filepath: '',
        log_message: '',
        uploaded_by: '',
        uploaded_at: new Date(),
    },
    dataStatesHistory: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'uploaded_at', dir: 'desc' }],
        filter: {
            logic: 'and',
            filters: [
                { field: 'type', operator: 'contains', value: 'Export Stockpile' },
            ],
        },
    },
    documentExport: {
        content: '',
        filename: '',
        filetype: '',
    },
    dataDropdownPit: [],
    dataDropdownSeam: [],
    dataDropdownArea: [],
    dataDropdownBrand: [],
    dataDropdownExcavator: [],
    dataDropdownContractor: [],
};
const adjustmentStockpileReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, countData } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: countData }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, isSubmit, isSuccess, isExport, mutationMode, isLoadingUpload, dataItemHistory, isLoadingModify, isLoadingDeleted, isLoadingHistory, isLoadingDownload, dataItemDeletedList, } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSubmit: isSubmit ? isSubmit : initialState.isSubmit, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, dataItemHistory: dataItemHistory
                ? dataItemHistory
                : initialState.dataItemHistory, isLoadingUpload: isLoadingUpload
                ? isLoadingUpload
                : initialState.isLoadingUpload, isLoadingModify: isLoadingModify
                ? isLoadingModify
                : initialState.isLoadingModify, isLoadingHistory: isLoadingHistory
                ? isLoadingHistory
                : initialState.isLoadingHistory, isLoadingDeleted: isLoadingDeleted
                ? isLoadingDeleted
                : initialState.isLoadingDeleted, isLoadingDownload: isLoadingDownload
                ? isLoadingDownload
                : initialState.isLoadingDownload, isExport: isExport ? isExport : initialState.isExport, dataItemDeletedList: dataItemDeletedList
                ? dataItemDeletedList
                : initialState.dataItemDeletedList });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map((item) => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isSubmit: false, isSuccess: false, isLoading: false, isLoadingModify: false, isLoadingExport: false, isLoadingUpload: false, isLoadingDeleted: false, isLoadingHistory: false, isLoadingDownload: false });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_GRID_DELETED_LIST]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingDeleted: false, dataGridDeletedList: action.payload.dataGridDeletedList, dataStatesDeletedList: Object.assign(Object.assign({}, state.dataStatesDeletedList), { total: action.payload.countData }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_PAGE_CHANGE_DELETED_LIST]: (state, action) => {
        const { dataStatesDeletedList } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStatesDeletedList, isLoading: true });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_FILTER_CHANGE_DELETED_LIST]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesDeletedList: Object.assign(Object.assign({}, state.dataStatesDeletedList), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_SORT_CHANGE_DELETED_LIST]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesDeletedList: Object.assign(Object.assign({}, state.dataStatesDeletedList), { isLoading: true, sort: action.payload }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload.isLoading });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_DELETE_STOCKPILE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { mutationMode: false, isSuccess: !action.payload.isError, isLoading: !action.payload.isError });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_GRID_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingHistory: false, dataGridHistory: action.payload.dataGridHistory, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { total: action.payload.countData }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_LAST_SUCCEED_UPLOAD]: (state, action) => {
        return Object.assign(Object.assign({}, state), { lastUpdated: action.payload.lastUpdated });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_PAGE_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: action.payload.dataStatesHistory });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_FILTER_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { filter: action.payload }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_SORT_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { sort: action.payload }) });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_SUMMARY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataTon: action.payload.dataTon, dataTrip: action.payload.dataTrip });
    },
    [stockpile_types_1.adjustmentStockpileTypes.ON_MODIFY_TICKET_STOCKPILE]: (state) => {
        return Object.assign(Object.assign({}, state), { isSuccess: true, isLoading: true, mutationMode: false });
    },
    [stockpile_types_1.adjustmentStockpileTypes.GET_DUMPTRUCK]: (state, action) => {
        const { dataDumptruck, dataItem } = action.payload;
        return Object.assign(Object.assign({}, state), { dataDumptruck,
            dataItem });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_PIT]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataDropdownPit: action.payload.dataDropdownPit });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_AREA]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataDropdownArea: action.payload.dataDropdownArea });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_SEAM]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataDropdownSeam: action.payload.dataDropdownSeam });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_BRAND]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataDropdownBrand: action.payload.dataDropdownBrand });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_EXCAVATOR]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataDropdownExcavator: action.payload.dataDropdownExcavator });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_CONTRACTOR]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingModify: false, dataDropdownContractor: action.payload.dataDropdownContractor });
    },
    [stockpile_types_1.adjustmentStockpileTypes.GET_CHECKPOINT]: (state, action) => {
        const { dataCheckpoint } = action.payload;
        const checkpoint_data = dataCheckpoint.find((item) => item.checkpoint_name === state.dataItem.checkpoint_name) || {
            checkpoint_id: '',
            checkpoint_name: '',
        };
        return Object.assign(Object.assign({}, state), { dataItem: Object.assign(Object.assign({}, state.dataItem), { checkpoint: {
                    checkpoint_id: checkpoint_data.checkpoint_id,
                    checkpoint_name: checkpoint_data.checkpoint_name,
                } }), dataCheckpoint });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_EXPORT_DOCUMENTS_URL]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingExport: false, isExport: true, documentExport: {
                filetype: 'xlsx',
                filename: action.payload.name,
                content: action.payload.content,
            } });
    },
    [stockpile_types_1.adjustmentStockpileTypes.CLEAR_EXPORT_DOCUMENTS_URL]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoadingExport: false, documentExport: {
                content: '',
                filename: '',
                filetype: '',
            } });
    },
    [stockpile_types_1.adjustmentStockpileTypes.SET_LOADING_EXPORT_EXCEL]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingExport: action.payload });
    },
});
exports.default = adjustmentStockpileReducer;
